export const OrganizationAdminApplicationId =
  "1ae0a1ed-30e1-4554-ba4c-a225f7e21abd";
